import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth.tsx";
import { ApiError } from "../lib/api.ts";

export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@demo.local");
  const [password, setPassword] = useState("ChangeMe!2026");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email.trim(), password);
      navigate("/");
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Falha ao autenticar");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-shell">
      <section className="login-hero">
        <div className="brand" style={{ padding: 0, fontSize: 16 }}>
          <span className="brand-mark">SE</span> Secure Endpoint
        </div>
        <h1 style={{ fontSize: 30, color: "#f8fafc" }}>Console de gestao de dispositivos</h1>
        <p style={{ color: "#b7c4d3", maxWidth: 460 }}>
          Inventario, conformidade e acoes remotas sobre endpoints corporativos — com fila de
          requisicoes, grupos, politicas e controle de acesso por papel.
        </p>
        <ul>
          <li>Inventario com busca, filtros e ordenacao</li>
          <li>Freeze, wipe, exclusao de arquivos, mensagens e scripts</li>
          <li>Paineis de status, risco, criptografia e conformidade</li>
          <li>Permissoes por papel: admin, analista, operador, visitante</li>
        </ul>
        <p style={{ color: "#7dd3c7", fontSize: 13 }}>
          Demonstracao com dados 100% sinteticos — nenhum dado real de endpoint.
        </p>
      </section>

      <section className="login-panel">
        <form className="login-card card" onSubmit={onSubmit} style={{ padding: 24 }}>
          <div>
            <h1>Entrar</h1>
            <p className="subtle">Use as credenciais de demonstracao preenchidas abaixo.</p>
          </div>
          {error ? <div className="alert error">{error}</div> : null}
          <div className="field">
            <label htmlFor="email">E-mail</label>
            <input
              id="email"
              className="input"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="field">
            <label htmlFor="password">Senha</label>
            <input
              id="password"
              className="input"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button className="btn primary" type="submit" disabled={busy} style={{ justifyContent: "center" }}>
            {busy ? "Verificando..." : "Entrar"}
          </button>
          <p className="muted" style={{ fontSize: 12.5 }}>
            Admin: admin@demo.local · Operador: operator@demo.local · Visitante: viewer@demo.local
          </p>
        </form>
      </section>
    </div>
  );
}
